import React, { createContext, useContext, useState, useCallback, useRef } from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import ConfirmD10SModal from '../components/ConfirmD10SModal';

const ConfirmD10SContext = createContext(null);

export function ConfirmD10SProvider({ children }) {
  const { t } = useLanguage();
  const [open, setOpen] = useState(false);
  const [step, setStep] = useState(1);
  const [firstMessage, setFirstMessage] = useState('');
  const [secondMessage, setSecondMessage] = useState('');
  const resolveRef = useRef(null);

  const confirm = useCallback((amount, action, options = {}) => {
    const amountStr = Number(amount).toFixed(2);
    const first = options.firstMessage ?? t('confirmD10S.first', { amount: amountStr, action });
    const second = options.secondMessage ?? t('confirmD10S.second');
    setFirstMessage(first);
    setSecondMessage(second);
    setStep(1);
    setOpen(true);
    return new Promise((resolve) => {
      resolveRef.current = resolve;
    });
  }, [t]);

  const handleConfirm = useCallback(() => {
    if (step === 1) {
      setStep(2);
    } else {
      if (resolveRef.current) resolveRef.current(true);
      resolveRef.current = null;
      setOpen(false);
    }
  }, [step]);

  const handleCancel = useCallback(() => {
    if (resolveRef.current) resolveRef.current(false);
    resolveRef.current = null;
    setOpen(false);
  }, []);

  return (
    <ConfirmD10SContext.Provider value={{ confirm }}>
      {children}
      <ConfirmD10SModal
        open={open}
        step={step}
        firstMessage={firstMessage}
        secondMessage={secondMessage}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />
    </ConfirmD10SContext.Provider>
  );
}

export function useConfirmSpendD10S() {
  const ctx = useContext(ConfirmD10SContext);
  if (!ctx) throw new Error('useConfirmSpendD10S must be used within ConfirmD10SProvider');
  return ctx;
}
